<template lang="html">
    <div>
        <!-- Top bar-->
        <microbiome-header/>
        <!-- Begin Page Content -->
        <components v-bind:is="Content" v-on:change-view="goPage" :properties="properties" />
    </div>
</template>



<script>
import Header from "@/views/Common/Header.vue";
import List from "@/views/Analysis/Microbiome/List2.vue";

export default {
  name: "Demultiplex",
  components: {
    "microbiome-header": Header,
    "microbiome-content": List
  },
  created() {},
  mounted() {
    //화면 새로고침시 기존 화면 불러오기
    if (this.$route.params.mid) {
      this.goPage({
        mid: this.$route.params.mid,
        type: this.$route.params.type
      });
    } else {
      this.goPage({ mid: sessionStorage.mid, type: sessionStorage.type });
    }
  },
  data() {
    return {
      Content: "",
      properties: [],
      menuHeaders: []
    };
  },
  methods: {
    goPage(data) {
      this.properties = data;
      this.Content = "microbiome-content";
      sessionStorage.removeItem("type");
      sessionStorage.removeItem("mid");
      sessionStorage.setItem("type", data.type);
      sessionStorage.setItem("mid", data.mid);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Analysis/Microbiome/Microbiome.vue